import React from 'react';

import moment from 'moment-tz';

import {BreadcrumbItemStructure} from 'app/general/structures/BreadcrumbItemStructure';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {ContentType} from 'sweet-types';

interface AnyProps {
  [other: string]: unknown;
}
interface CreateDocBreadcrumbProps extends AnyProps {
  ct: ContentType;
}

export const CreateDocBreadcrumb = ({
  ct,
  ...other
}: CreateDocBreadcrumbProps): JSX.Element => (
  <BreadcrumbItemStructure
    text={gt('Create %s', getContentType(ct).name)}
    {...other}
  />
);

interface DocVersionBreadcrumbProps extends AnyProps {
  version?: {
    approved_at?: string | null;
    is_current: boolean;
    created_at: string;
  };
}

export const DocVersionBreadcrumb = ({
  version,
  ...other
}: DocVersionBreadcrumbProps): JSX.Element | null =>
  version != null ? (
    <BreadcrumbItemStructure
      text={
        version.approved_at != null
          ? version.is_current === true
            ? gt('Live version')
            : gt('Version edited %s', moment(version.created_at).format('lll'))
          : gt('Draft edited %s', moment(version.created_at).format('lll'))
      }
      {...other}
    />
  ) : null;

interface DocNameBreadcrumbProps extends AnyProps {
  docName: string;
}

export const DocNameBreadcrumb = ({
  docName,
  ...other
}: DocNameBreadcrumbProps): JSX.Element => (
  <BreadcrumbItemStructure text={docName} shrinkText={true} {...other} />
);

export const EditDocBreadcrumb = ({...other}: AnyProps): JSX.Element => (
  <BreadcrumbItemStructure icon="fa-pen" text={gt('Editing')} {...other} />
);

export const createStaticTextBreadcrumb = (
  text: string
): ((props: AnyProps) => JSX.Element) =>
  function StaticTextBreadcrumb(props: AnyProps): JSX.Element {
    return <BreadcrumbItemStructure {...props} text={text} shrinkText={true} />;
  };
